(function(app) {

    app.provider("marketplaceOneApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getToken = function () {
                        return portalApiGateway.get("/MarketplaceOne/Token");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);